import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";

export class SortVehicleTypeImgCommand extends IRequestCommand<
    ICommandResponse,
    ErrorDetails,
    Array<any>
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierId}/transportTypes/{transportTypeId}/sortTransportsImg';

  setUrlParameters(carrierId: string, transportTypeId: number) {
    this._commandUrl = this._commandUrl.replace('{carrierId}', carrierId.toString());
    this._commandUrl = this._commandUrl.replace('{transportTypeId}', transportTypeId.toString());
  }

  public override setParameters(parameters: Array<any>) {
    this._commandBody = parameters;
  }
}

export interface ISortVehicleTypeImgCommandParameters {
    carrierId: string;
    transportTypeId: number;
}
